import {NfMessage, NfMessageType} from "../NfMessage";
import {ComponentTypes} from "../ComponentTypes";

/**
 * Wiadomość, od komponentu, gdy komponent musi się ponownie zarejestrować
 */
export class ComponentRefresh extends NfMessage {

    /**
     * Ta wiadomość powinna również zawierać port komunikacji (this.communicationPort), przekazany poprzez parametr transfer w postmessage
     * @param serviceInstanceId id instancji booking engine, -1 jeśli to nowa instancja
     * @param widgetId Id widgeta (id dla backendu NfHotel)
     * @param browserTabId Id zakładki przeglądarki
     * @param componentType typ komponentu
     * @param requestedGlobalMessageTypes globalne wiadomości, które chce otrzymywać ten komponent (np. wynik wyszukiwania dostępności)
     * @param uuid unikalny id komponentu który jest rejestrowany
     */
    public constructor(serviceInstanceId: number|MessageEvent<ComponentRefresh>, widgetId?: number,
                       browserTabId?: string, componentType?: ComponentTypes, requestedGlobalMessageTypes?: NfMessageType[],
                       uuid?: number, componentId?:number) {
        super(NfMessageType.ComponentRefresh);
        if(NfMessage.isMessageEvent(serviceInstanceId)) {
            Object.assign(this, serviceInstanceId.data);
        } else {
            this.serviceInstanceId = serviceInstanceId;
            if(widgetId) {
                this.widgetId = widgetId;
            } else {
                throw Error("widgetId jest wymagane");
            }
            if(browserTabId) {
                this.browserTabId = browserTabId;
            }
            if(componentType) {
                this.componentType = componentType;
            } else {
                throw Error("componentType jest wymagane");
            }
            if(requestedGlobalMessageTypes) {
                this.requestedGlobalMessageTypes = requestedGlobalMessageTypes;
            } else {
                throw Error("requestedGlobalMessageTypes jest wymagane");
            }
            if(uuid) {
                this.uuid = uuid;
            } else {
                throw Error("uuid jest wymagane");
            }
            if(typeof (componentId) != 'undefined') {
                this.componentId = componentId;
            } else {
                throw Error("componentId jest wymagane");
            }
        }
    }
    public type = NfMessageType.ComponentRefresh;
    /**
     * id instancji booking engine, -1 jeśli to nowa instancja
     */
    public serviceInstanceId:number = -1;
    /**
     * Id widgeta (id dla backendu NfHotel)
     */
    declare public widgetId: number ;
    /**
     * Id zakładki przeglądarki
     */
    declare public browserTabId: string ;
    /**
     * Typ komponentu
     */
    public componentType: ComponentTypes = ComponentTypes.MainModal;

    public requestedGlobalMessageTypes: NfMessageType[] = [];
    public uuid: number = 0;
    public componentId: number = 0;
}

NfMessage.creationCallbacks[NfMessageType.ComponentRefresh] = (event) => {
    const message =  new ComponentRefresh(event);
    return message;
}
